import React from 'react';

const SiteMapHeader = () => {
  return (
    <div className="page-hero-bg relative overflow-hidden text-white text-center bg-gradient-to-br from-icetex to-icetex-dark py-[80px] px-5">
      <div className="mx-auto relative z-10 max-w-[800px]">
        <h1
          className="font-extrabold mb-5"
          style={{ fontSize: '3rem', textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)' }}
        >
          Mapa del Sitio
        </h1>
        <p
          className="mx-auto opacity-[0.95]"
          style={{ fontSize: '1.2rem', lineHeight: '1.8', maxWidth: '700px' }}
        >
          Navegación completa de todas las secciones y recursos disponibles en los Cursos Virtuales ICETEX
        </p>
      </div>
    </div>
  );
};

export default SiteMapHeader;
